// TODO: Consolidate with newer WO API types; these may be out of date

import { WiseOwlMessage } from "./wiseOwlApi";

// WiseOwl API types

export interface OneAdminApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

// Responses
export type FetchChatByIdResponse = OneAdminApiResponse<ChatWithMessages>;
export type SendMessageResponse = OneAdminApiResponse<SendMessageData>;
export type CreateChatResponse = OneAdminApiResponse<CreateChatData>;
export type FetchChatHistoryResponse = OneAdminApiResponse<GetChatHistoryData>;

// Request Bodies & Params
export interface CreateChatRequestBody {
  input: string;
}

export interface SendMessageRequestBody {
  input: string;
}

export interface SendMessageParams {
  chatId: string;
  chatData: SendMessageRequestBody;
  bearerToken?: string;
}

export interface SendMessageData {
  chat: ChatWithMessages;
}

// Supporting objects
export interface ChatWithMessages extends WiseOwlOneAdminChat {
  messages: WiseOwlMessage[];
}

export interface CreateChatData {
  chat: ChatWithMessages;
}

export interface GetChatHistoryData {
  chats: WiseOwlOneAdminChat[];
}

// TODO: Consolidate with WiseOwlChat in wiseOwlApi once 1A is updated
export interface WiseOwlOneAdminChat {
  createdAt: string;
  id: string;
  ingress: string;
  slackConversationId: string | null;
  slackThreadTimestamp: string | null;
  title: string;
  updatedAt: string;
  userId: string;
}

// Legacy message - only support temporarily for 1A
export enum DataSource {
  TwilioCom = "TWILIO_COM",
  SendGridCom = "SENDGRID_COM",
  SegmentCom = "SEGMENT_COM",
  HelpTwilioCom = "HELP_TWILIO_COM",
  AuthyCom = "AUTHY_COM",
  GoogleDrive = "GOOGLE_DRIVE",
  TwilioOrg = "TWILIO_ORG",
}

export enum Ingress {
  Web = "WEB",
}

export interface MessageContext {
  id: number;
  createdAt: string;
  updatedAt: string;
  messageId: number;
  dataSource: DataSource | string;
  title: string;
  content: string;
  url: string;
}

export interface LegacyWiseOwlAuthor {
  alias: string;
  displayName: string;
  isAuthor: boolean;
  isEndUser: boolean;
  name: string;
}

export interface LegacyWiseOwlMessage {
  author: LegacyWiseOwlAuthor;
  body: string;
  createdAt: string;
  htmlBody: string;
  hasError?: boolean;
  handleResend?: (retryId: string) => void;
  retryId?: string;
}

export interface ChatHistoryDropdownItem {
  id: string;
  title: string;
  updatedAt: string;
  url: string;
}
